// extracted by mini-css-extract-plugin
export default {"formDwg":"FileConfigStyle_formDwg__8EofS"};